import { useEffect } from 'react';
import { useFlashTransition } from 'hooks/useFlashState';

export type FlashErrorDetails = {
  hasError: boolean;
  message: string | undefined;
};

export const useFlashErrorDetails = (
  target?: FlashErrorDetails,
  isVisible: boolean = true
) => {
  const [message, showMessage, flashMessage] = useFlashTransition();

  useEffect(() => {
    if (target?.hasError) {
      flashMessage(target.message);
    }
  }, [flashMessage, target?.hasError, target?.message]);

  return { message, showMessage: showMessage && isVisible };
};
